import styled from "styled-components";

const getNextTheme = ({ theme }) =>
  `background-color: ${theme.color.line.light};
 color:  ${theme.color.brandPrimary.light};
 border: none;`;

const getSelectTheme = ({ selected, theme }) =>
  !selected
    ? `background: ${theme.color.line.light};
     `
    : `background: linear-gradient(224.14deg, #FFA600 -11.69%, #F36800 100%);
        color: ${theme.color.line.light} !important;`;

export const ModalWidgetCard = styled.div`
  max-width: none;
  & > .Card__Header {
    display: grid;
    grid-template-columns: 33% 33% 33%;
  }

  & > .Card__Body {
    justify-content: center;
    display: flex;
  }
`;

export const NextAndPreviousButtons = styled.button`
  min-width: 0;
  width: 40px;
  height: 40px;
  padding: 0;
  ${getNextTheme}
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    font-size: 24px;
  }
`;

export const PagesButtonsContent = styled.div`
  display: flex;
`;

export const TresBotoesPaginacao = styled.button`
  min-width: 0;
  width: 40px;
  height: 40px;
  padding: 0;
  ${getSelectTheme};
  display: flex;
  align-items: center;
  justify-content: center;
`;
